import { Button, Flex, Form, Input, Modal, Rate, Result } from "antd";
import { useSearchParams } from "react-router-dom";
import Navbar from "../../components/navbar";
import { format } from 'date-fns';
import { useMutation } from "@apollo/client";
import { INSERT_REVIEW } from "../../apollo/mutation/reivew.mutation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Review = () => {
    /** Retrieve param from url */
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const [ insertReview, { data } ] = useMutation(INSERT_REVIEW);
    const { t } = useTranslation();
    const [confirmation, setConfirmation] = useState(false);

    const onClose = () => {
        setConfirmation(false);
        form.resetFields();
    }

    useEffect((): void => {
        if( data?.code === 200 || data?.code === 200 ) {
            setConfirmation(true);
        }
    }, [data]);
    

    const handleSubmit = (values: any) => {
        const review = { ...values, dDate: format(new Date(), 'yyyy-MM-dd'), nIDRestaurant: parseInt(searchParams.get('nIDRestaurant') as string)}
        insertReview({ variables: { review: review }});
    };

    return (
        <Flex align="center" justify="center" style={{ height: '100%', width: '100%', backgroundColor: '#1F1F1F', padding: 10, position: 'relative' }}>
            <Navbar nIDRestaurant={parseInt(searchParams.get('nIDRestaurant') as string)} />
            <img src={`https://api.ams-carriot-restaurant.com/restaurant-image/${parseInt(searchParams.get('nIDRestaurant') as string)}`} alt="AMS Restaurant" />
            {/* Main Form */}
            <div style={{ backgroundColor: 'white', borderRadius: 10, padding: 20, boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', width: '70%', position: 'absolute', top: '20%', zIndex: 2 }}>
                <h1 style={{ fontSize: '1.2rem', fontFamily: 'Roboto-Bold', marginBottom: 10}}> { t('review.title') } </h1>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    className="space-y-6"
                >
                    <div>
                        <Form.Item
                            label={ t('label.guest-name') }
                            name="sCustomerName"
                            rules={[
                                { required: true, message: t('label.enter-name') },
                            ]}
                        >
                            <Input style={{ height: 50 }} placeholder={ t('label.placeholder-name') } />
                        </Form.Item>
                        <Form.Item
                            label={ t('label.waiter-name') }
                            name="sWaiterName"
                            rules={[
                                { required: true, message: t('label.enter-waiter') },
                            ]}
                        >
                            <Input style={{ height: 50 }} placeholder={ t('label.enter-waiter-placeholder') } />
                        </Form.Item>
                        <Form.Item name="rating" label="Rating">
                            <Rate />
                        </Form.Item>
                        <Form.Item
                            label={ t('label.review') }
                            name="sReview"
                            rules={[
                                { required: true, message: t('label.enter-review') },
                            ]}
                        >
                            <Input.TextArea autoSize style={{ minHeight: 50 }} placeholder={ t('label.enter-review-placeholder') } />
                        </Form.Item>
                    </div>
                    <div style={{ paddingTop: 20 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ width: '100%', height: 50 }}
                        >
                            { t('buttons.send-review') }
                        </Button>
                    </div>
                </Form>
            </div>
            <Modal open={confirmation} footer={null} onCancel={() => setConfirmation(false)}>
                <Result
                    status="success"
                    title={ t('review.review-confirmation-title') }
                    subTitle={ t('review.review-confirmation-description') }
                    extra={[
                    <Button type="primary" key="ok" onClick={onClose}>
                        { t('buttons.ok') }
                    </Button>,
                    ]}
                />
            </Modal>
        </Flex>
    );
}

export default Review;